import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import StorageSvg from '../../../assets/icons/app/storage.svg?raw';

export const StorageIcon = (props) => <CustomSVG svg={StorageSvg} preserveColors appIconSmall {...props} />;
